import BeschreibungDTO from '../Monitoring/BeschreibungDTO'

export default class FormConfigDto {
  constructor(json) {
    if(json) {
      this.id = json.id
      this.formKey = json.formKey
      this.beschreibung = new BeschreibungDTO(json.beschreibung)
      this.monitoringEmails = json.monitoringEmails ?? []
      this.accessEmails = json.accessEmails ?? []
    }
  }

  get formName() {
    return this.beschreibung.text
  }

}

